import type { FaireProductEntity } from "../../entity_types/product";

export const p_pdr6j73eqe: FaireProductEntity = {
  token: "p_pdr6j73eqe",
  type: "product",
  name: "Evil Eye 18K Gold Plated SS Triple Layer Stacked Ring - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/48f93c2c5c93eb92271e540ba0740a870a97c483a04dcd8889cf2345ce593b48.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c1cb4b78db43b7ce1fea363234df036a58e065428b767e93bcd796bddfe0ae2.jpeg",
    "https://cdn.faire.com/fastly/089658c68bb529fe8e4c47a5f1e48820ded732c262c88e6d2b7a4d0ea3c501a2.jpeg",
  ],
  priceDollars: 7.69,
  description:
    "Type: Ring\nMaterial : Stainless steel ，18K gold plated ， Imitation，turquoise\nSize ： 7# ，adjustable\nProcess: Vacuum electroplating and manual polishing，Non - tarnish\nSurface : High Polish\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n★Perfect jewelry gifts\n ",
  tags: [],
  msrpDollars: 18.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:27.563Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
